export default {
    toc_1: 'Ambulatory Care',
    toc_2: 'Emergency Department',
    toc_3: 'Home Health',
    toc_4: 'Inpatient Care',
    toc_5: 'Nursing Facility',
    toc_6: 'Pharmaceutical',
    toc_7: 'All types of care',
};
